import React, { FC, useEffect, useState } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { PatientItem } from '../../ListItems/PatientItem'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { handleAboutModal } from '../../../features/modals/modalsSlice'
import { ModalContentProps } from '../../Modal'
import { HeartIcon, LogoLongIcon, Scanner } from '../../../icons'
import { YellowButton } from '../../YellowButton'
import { OrderCard } from '../../OrderCard'
import { DocumentItem } from '../../ListItems/DocumentItem'
import { getUserDocument } from '../../../features/profile/profileSlice'
import Skeleton from 'react-loading-skeleton'
import useTheme from '../../../hooks/useAppColor'
import packageJson from "../../../../package.json"
import { useNavigate } from 'react-router-dom'

export const AboutAppModalContent: FC<ModalContentProps> = ({ handleModal, level }) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()
    const { document } = useAppSelector(state => state.profile)
    const [pashalka, setPashalka] = useState<number>(1)
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(getUserDocument())
    }, [])

    return (
        <BorderedPageLayout
            modal={{ level: level || 1 }}
            handleModal={handleModal}
            contentClassName='f-column gap-40'>
            <div className="d-f jc-between">
                <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
                <p className='c-dark fw-5 fz-l fw-6'>О приложении</p>
                <div className='f-03'></div>
            </div>

            <div className="gap-35 f-column">
                <div className="f-column gap-15" onClick={() => {
                    setPashalka(pashalka + 1)
                    if(pashalka === 5){
                        navigate("/qr-reader")
                        dispatch(handleAboutModal())
                    }
                }}>
                    <LogoLongIcon/>
                    <div style={{ maxWidth: 230 }} className="f-column gap-10">
                        <div className="f-row-betw">
                            <p className={`fz-m c-lg`}>Версия</p>
                            <p className={`fz-m c-dark`}>{packageJson.version}</p>
                        </div>
                    </div>
                </div>
                <div className={`f-column gap-15`}>
                    <h2 className={`title ${getTheme("c-black", "c-white")}`}>Документы</h2>
                    <div className="f-column">
                        {
                            document.loading ? <Skeleton borderRadius={6} height={50} /> : <DocumentItem to={document.url} title={"Договор о сотрудничестве"} />
                        }
                        <DocumentItem to={'https://expresstest.ru/soglasie'} title={"Согласие на обработку персональных данных"} />
                    </div>
                </div>

            </div>

        </BorderedPageLayout>
    )
}
